import { Component, ElementRef, OnInit, Renderer2 } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";
import { MadAuthService } from "src/app/core/mad-auth/mad-auth.service";
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-hampton-login',
  templateUrl: './hampton-login.component.html',
  styleUrls: ['./hampton-login.component.scss'],
})
export class HamptonLoginComponent implements OnInit {
  private _dubaiHour$ = new BehaviorSubject<number>(getDubaiHour())
  private _theme$ = this._dubaiHour$.asObservable().pipe(map((hour) => getTheme(hour)))
  photo$ = this._theme$.pipe(map(theme => theme.photo))
  greeting$ = this._theme$.pipe(map(theme => theme.greeting))

  constructor(
    private _elementRef: ElementRef<HTMLElement>,
    private _authService: MadAuthService,
    private _renderer2: Renderer2
  ) {
    this._loadLoginScript()
  }

  ngOnInit(): void {
    this._playSplashScreen()
  }

  private _loadLoginScript() {
    const prod = environment.production
    if (prod) {
      const redirectURL = environment.outsetaRedirectURL
      const url = `${redirectURL.protocol}://hamptons.interval-soft.com/mad-auth/redirect`
      this._authService.loadLoginScript(this._renderer2, url)
    } else {
      const url = 'http://app.localhost:4200/mad-auth/redirect'
      this._authService.loadLoginScript(this._renderer2, url)
    }
  }

  private _playSplashScreen() {
    const el = this._elementRef.nativeElement
    const splash = this._elementRef.nativeElement.querySelector<HTMLElement>('.splash-screen')
    const splashLogo = this._elementRef.nativeElement.querySelector<HTMLElement>('.splash-logo')
    const splashAccent = this._elementRef.nativeElement.querySelector<HTMLElement>('.splash-accent')
    const photoLayer = this._elementRef.nativeElement.querySelector<HTMLElement>('.photo-layer');
    const logoContainer = this._elementRef.nativeElement.querySelector<HTMLElement>('.logo-container');

    photoLayer.classList.add('revealed')

    setTimeout(function () {
      splashLogo?.classList.add('visible')
    }, 400)

    setTimeout(function () {
      splashLogo?.classList.add('breathing')
      splashAccent?.classList.add('visible')
    }, 1200)

    setTimeout(function () {
      splashLogo.classList.remove('breathing')
      splashAccent.classList.add('dissolving')

      setTimeout(function () {
        // FLIP: Get splash logo current position (First)
        var splashRect = splashLogo.getBoundingClientRect();

        // FLIP: Get target logo position (Last)
        var targetRect = logoContainer.getBoundingClientRect();

        // Set splash logo to fixed positioning at its current location
        splashLogo.style.position = 'fixed';
        splashLogo.style.left = splashRect.left + 'px';
        splashLogo.style.top = splashRect.top + 'px';
        splashLogo.style.width = splashRect.width + 'px';
        splashLogo.style.margin = '0';
        splashLogo.style.zIndex = '600';

        // Keep blue backdrop solid during flight — logo is white, needs contrast
        // Force reflow before applying morph target
        splashLogo.offsetHeight;

        // FLIP: Animate to target position (Play) — stay fully visible
        splashLogo.classList.add('morphing');
        splashLogo.style.left = targetRect.left + 'px';
        splashLogo.style.top = targetRect.top + 'px';
        splashLogo.style.width = targetRect.width + 'px';

        setTimeout(function () {
          logoContainer.classList.remove('awaiting-morph');
          splashLogo.style.display = 'none'

          splash.classList.add('dissolving')

          _initLogoRotation(el)

          setTimeout(function () {
            splash.classList.add('hidden')
          }, 1200)
        }, 1000)
      }, 120)
    }, 3800)
  }

}

function _initLogoRotation(el: HTMLElement) {
  var logoEn = el.querySelector('.logo-english')
  var logoAr = el.querySelector('.logo-arabic')

  let showArabic = false
  setInterval(function () {
    showArabic = !showArabic
    if (showArabic) {
      logoEn.classList.add('hidden')
      logoAr.classList.add('visible')
    } else {
      logoEn.classList.remove('hidden')
      logoAr.classList.remove('visible')
    }
  }, 5000)
}

export function getDubaiHour() {
  const now = new Date()
  const utc = now.getTime() + now.getTimezoneOffset() * 60000;
  const dubai = new Date(utc + 4 * 3600000)
  return dubai.getHours() + dubai.getMinutes() / 60
}

export function getTheme(hour: number) {

  if (hour >= 6 && hour < 12) {
    return {
      photo: 'assets/media/hamptons/Dubai-morning.webp',
      greeting: 'Good morning'
    }
  }
  if (hour >= 12 && hour < 17) {
    return {
      photo: 'assets/media/hamptons/Dubai-afternoon.webp',
      greeting: 'Good afternoon'
    }
  }
  if (hour >= 17 && hour < 19) {
    return {
      photo: 'assets/media/hamptons/Dubai-afternoon.webp',
      greeting: 'Good afternoon'
    }
  }
  if (hour >= 19 && hour < 22) {
    return {
      photo: 'assets/media/hamptons/Dubai-evening.webp',
      greeting: 'Good evening'
    }
  }
  return {
    photo: 'assets/media/hamptons/Dubai-evening.webp',
    greeting: 'Good evening'
  }
}